"use strict";

import getNgModule from "getNgModule";
const ngModule = getNgModule(__filename);

ngModule.directive("obsSocialTwitterButton", function() {
    return {
        restrict    : "E",
        scope       : true,
        replace     : true,
        template    : require("./obsSocialTwitterButton.html"),
        link : function($scope, $el, $attrs) {

            !function(d,s,id) {
                var js,
                    fjs=d.getElementsByTagName(s)[0],
                    p=/^http:/.test(d.location)?'http':'https';

                if(!d.getElementById(id)){
                    js=d.createElement(s);
                    js.id=id;
                    js.src=p+'://platform.twitter.com/widgets.js';
                    fjs.parentNode.insertBefore(js,fjs);
                }
            }(document, 'script', 'twitter-wjs');

        }
    };
});


// WEBPACK FOOTER //
// ./src/apps/observatoire/ng/social/obsSocialTwitterButton.js